import { clsx } from "external/clsx"
import { useMemo } from "external/react"


export default function FormTextArea (props) {
    const {fieldName, error, defaultValue, value, placeholder, onChange, rows, maxLength, className, children, submitted, controlProps} = props
    const errorType = useMemo(() => Array.isArray(error) ? 'multiple' : (error && 'simple'), [error])
    const errorClass = useMemo(() => errorType === 'simple' && submitted ? 'visible' : 'invisible', [errorType, submitted])
	return (
        <>
        <div className={clsx('form-group', 'mt-2', 'mb-1', className)}>
            <textarea defaultValue={defaultValue} value={value} placeholder={placeholder} name={fieldName} rows={rows} maxLength={maxLength} onChange={onChange} {...controlProps} />
              {children}
        </div>
        {errorType !== 'multiple' && (<small className={clsx('text-danger', errorClass)}>{error || '&nbsp;'}</small>)}
        {submitted && errorType === 'multiple' && error.length > 0 && (
            <div>
                <ul className='text-danger' style={{ fontSize: '12px', margin: 'auto' }}>
                    {error.map((text, key) => (<li key={key}>{text}</li>))}
                </ul>
            </div>
        )}
        </>
	)
}